import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';

export class ChapterNinetyThree extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">
            <div className="text-title-holder">
              <p>{ this.props.textTitle }</p>
            </div>
            <div className="text-holder">
              <p>In the last few years Chinese tech giants Alibaba and Tencent have
              <a href="http://fortune.com/2018/06/21/alibaba-tencent-southeast-asia/"> greatly deepened their investment in SEA. </a>
              In 2018, both went further, Alibaba doubled their stake in e-commerce company Lazada to $4b, while Tencent participated in Go-Jek’s $1.5b Series E. </p>

            </div>
          </div>
        </div>


        <textHolder text="It is difficult to forecast with any accuracy whether other Internet giants from China (or the US) will snap up digital properties in the region. If they do so, it will be their way of entering a new market while staving off competition. There are certainly properties which are at a stage of development that make them ripe for acquisition." />

        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">
            <div className="text-title-holder">
              <p>{ this.props.textTitle }</p>
            </div>
            <div className="text-holder">
              <p>Not everyone is happy about China’s burgeoning influence. In August 2018, Malaysian Prime Minister Mahathir Mohamad made headlines by
              <a href="https://www.straitstimes.com/asia/se-asia/vietnam-vows-cryptocurrency-crackdown-after-864m-fraud"> canceling two major infrastructure projects </a>
              associated with China’s Belt and Road Initiative. The Prime Minister said that the projects, which were initiated by his predecessor, were unnecessary and unaffordable; he also implied that they would leave his country in too much debt to China.</p>

            </div>
          </div>
        </div>

        <TextHolder />









          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/93.js